/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { Link, NavLink } from "react-router-dom"
import { Image, Space } from "antd";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import clsx from "clsx";
import { gabHead } from "../../../../../config/constant";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const ListTable = (props) => {
    const [addressId, setAddressId] = useState(false);
    const [name, setName] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const { details, onSelected, onRequestSort, sortOrder, sortBy, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;

    const [selected, setSelected] = useState([]);
    const onDelete = (data) => {
        setDeleteModal(true);
        setAddressId(data.id);
        setName(data.businessName);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    useEffect(() => {
        onSelected(selected);
    }, [selected]);


    const isSelected = (name) => selected.indexOf(name) !== -1;

    const address = (data) => {
        let address = data.address1 ? data.address1 + ', ' : '';
        address += data.area ? data.area.name : '---';
        address += data.city ? ', ' + data.city.name : '---';
        address += data.state ? ', ' + data.state.name : '---';
        address += data.country ? ', ' + data.country.name : '---';
        address += data.pincode ? ', ' + data.pincode.code : '';
        return address;
    }

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={gabHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                width={true}
                sortBy={sortBy}
                details={details}
                className={classes.margin15t}
                selected={selected}
                onSelected={(value) => setSelected(value)}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={gabHead?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} onClick={(e) => handleClick(e, data.id)}>
                                                <TableCell className={clsx('checkbox', classes.tablealign)} padding="checkbox"><Checkbox color="primary"
                                                    checked={isSelected(data.id)} /></TableCell>
                                                <TableCell style={{ width: getColumnWidth(gabHead, 1) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Global Address Book', 'view', 'Younote Admin') ?
                                                            <Link style={{ width: getColumnWidth(gabHead, 1) }} to={`/younote-admin/home/global-address-book/${data.id}/view`} className={clsx(classes.color, classes.bold)}>{data?.businessName || data?.contactName || '---'}</Link>
                                                            : <span style={{ width: getColumnWidth(gabHead, 1) }}>{data.serialNo ? data.serialNo : '---'}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(gabHead, 2) }}><span style={{ width: getColumnWidth(gabHead, 2) }}>{data.id}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(gabHead, 3) }}><span style={{ width: getColumnWidth(gabHead, 3) }}>{data.businessId ? `YOU${data.businessId}` : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(gabHead, 4) }}><span style={{ width: getColumnWidth(gabHead, 4) }}>{data.mobile}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(gabHead, 5) }}><span style={{ width: getColumnWidth(gabHead, 5) }}>{address(data)}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(gabHead, 6) }}><span style={{ width: getColumnWidth(gabHead, 6) }}>{data.isPrimary ? 'Yes' : 'No'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Global Address Book', 'view', 'Younote Admin') &&
                                                            <Link to={`/younote-admin/home/global-address-book/${data.id}/view`}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        {/* <Link to={`/admin/home/global-address-book/${data.id}/edit`}>
                                                <Image
                                                    src={EditIcon}
                                                    preview={false}
                                                />
                                            </Link> */}
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Global Address Book', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={gabHead?.length}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>There are no Signed-in Users</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={addressId} loadTasks={() => loadTasks()} name={name} url={'addressBook'} title={'Address Book'} visible={deleteModal} />
        </>
    )
}
